import { StyledReportCellRow, StyledReportParagraph } from "./styled";
import React from "react";

type ReportCellTripleColProps = {
  labelA: string;
  labelB: string;
  text: string;
} & StyledReportParagraph;
export const ReportCellTripleCol: React.FC<ReportCellTripleColProps> = ({
  labelA,
  labelB,
  text,
  ...rest
}) => {
  return (
    <>
      <StyledReportCellRow>
        <StyledReportParagraph
          className="cell-labelA"
          fontWeight="600"
          {...rest}
        >
          {labelA}
        </StyledReportParagraph>
        <StyledReportParagraph
          className="cell-labelB"
          fontWeight="600"
          {...rest}
        >
          {labelB}
        </StyledReportParagraph>
        <StyledReportParagraph fontWeight="400" {...rest}>
          {text}
        </StyledReportParagraph>
      </StyledReportCellRow>
    </>
  );
};
